export default __webpack_public_path__ + "static/media/datetimepicker.4acd71c1.svg";